import {ListItem} from "@mui/material";
import React from "react";

const ListItemLink = (props) => {
    const {className, ...fieldProps} = props;

    return <ListItem className={`listItemLink ${className}`} component="a" {...fieldProps} />;
}

export {ListItemLink};